export const statuses = {
  pending: 'pending',
  success: 'success',
  failure: 'failure',
};
